import React from 'react';
import { Title as TendUITitle } from '@10d/tend-ui/typography/Title';
import { ITitleProps } from './types';

const Title: React.FC<React.PropsWithChildren<ITitleProps>> = ({ testId, ...props }) => {
  return <TendUITitle data-testid={testId} margin={0} {...props} />;
};

export default Title;
